module.exports = __webpack_public_path__ + "static/media/sz.59e2dbc4.svg";